import React, { Component,ReactElement,useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import {
  servicePageHeader,
  serviceSkills,
} from "../../portfolio";
import "./service.css";
import ServiceImg from "./serviceImg";
import { patiApi } from '../../components/misc/PatiApi'
import {handleLogError} from "../../components/misc/Helpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Link from "../../components/html/link";

type ContactFormData = {
  [key: string]: any; 
}
type LoginRequestState = { running?: boolean,isError?:boolean, error?: string,successful?:boolean,message?:string,};
type Props = {theme: ThemeProps,}
type SSkils = {
  skillName: string,
  fontAwesomeClassname?: string,
  imageSrc?:string,
  style?: {
  },
}
export default function Service({ theme }: Props) {
		const { t, i18n } = useTranslation();
    const [inputFields, setInputFields] = useState<ContactFormData>({title:"",name:"",organisation:"",phone:"",email:"",message:"",errors:{}});
    const [loginRequestState,setLoginRequestState,] = React.useState<LoginRequestState>({ running: false});
    
    const handleLoginT = (event:React.FormEvent<HTMLFormElement>) => {
			event.preventDefault();
			console.log(inputFields);
			const errorsN:ContactFormData = {};
			for (const el of document.getElementById('form')!.querySelectorAll("[required]")) {
			  if (!(el as HTMLInputElement).reportValidity()) {
			    errorsN[(el as HTMLInputElement).name] = 'invalid';
			  }
  		}
  		inputFields.errors=errorsN;
  		setInputFields(inputFields);
		}
    
    const handleFormChange = (event:React.ChangeEvent<HTMLInputElement>) => {
		   inputFields[event.target.name] = event.target.value;
		   setInputFields(inputFields);
		}
		
    async function handleLogin(event:React.FormEvent<HTMLFormElement>) {
			event.preventDefault();
			console.log(inputFields);
			const errorsN:ContactFormData = {};
			for (const el of document.getElementById('form')!.querySelectorAll("[required]")) {
			  if (!(el as HTMLInputElement).reportValidity()) {
			    errorsN[(el as HTMLInputElement).name] = 'invalid';
			  }
  		}
  		inputFields.errors=errorsN;
  		setInputFields(inputFields);
			
			setLoginRequestState({
				running: true,
			});
			if (!(inputFields.email ||  inputFields.name || inputFields.phone || inputFields.message)) {
				console.log("ERRRRRRRRRRRRR");
				setLoginRequestState({ isError: true,});
				return
			}
	
			patiApi.contact(document.querySelector("form.contactform")!)
				.then(response => {
					setLoginRequestState({
						isError: false,
	          message: response.data,
	          successful: true
					})
				}).catch(error => {
					handleLogError(error)
					setLoginRequestState({ isError: true })
				})
		}
		
		function renderServerError(): ReactElement {
        return (
            <p className="error-message">
              Something went wrong. Please try again later.
            </p>
        )
    }  

		
    return (
		<PageLayout title="Home" theme={theme}>
      <div className="projects-main">
        <div className="basic-projects">
          <Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <ServiceImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1 className="projects-heading-text">{t(servicePageHeader.title)}</h1>
                <p className="projects-header-detail-text subTitle">
                	{servicePageHeader.description.map((skillSentence) => {
                      return (
												<div>{t(skillSentence)}</div>
                      );
                    })}
                </p>
                <div className="portfolio-repo-btn-div" style={{display:"flex",justifyContent:"center"}}>
                <Link
                  text="Kontak aufnehmen"
                  href="/contact"
                  className="portfolio-repo-btn"
                />
              	</div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      
      
      <div className="service main">
        
        <div>
        {serviceSkills.data.map((skill) => {
          return (
            <div className="skills-main-div">
              <div className="skills-text-div">
                <Fade direction="right" duration={1000} triggerOnce={true}>
                  <h1 className="skills-heading" style={{ color: theme.text }}>
                    {t(skill.title)}
                  </h1>
                </Fade>
                
                <Fade direction="right" duration={2000} triggerOnce={true}>
                  <div>
                    {skill.skills.map((skillSentence) => {
                      return (
                        <p
                          className="subTitle skills-text"
                          style={{ color: theme.secondaryText }}
                        >
                          {t(skillSentence)}
                        </p>
                      );
                    })}
                  </div>
                </Fade>
                
                <Fade direction="right" duration={1500} triggerOnce={true}>
                 
                 	<div>
						        <div className="software-skills-main-div">
						          <div className="dev-icons row">
						            {/* {skillsSection.softwareSkills.map(skills => {
						            return (
						              <li className="software-skill-inline" name={skills.skillName}>
						                <i className={skills.fontAwesomeClassname}></i>
						              </li>
						            );
						          })} */}
						            {skill.softwareSkills.map((logo:SSkils) => {
						              return (
						                <OverlayTrigger
						                  key={logo.skillName}
						                  placement={"top"}
						                  overlay={
						                    <Tooltip id={`tooltip-top`}>
						                      <strong>{logo.skillName}</strong>
						                    </Tooltip>
						                  }
						                >
						                  <div className="software-skill-inline col-sm serviceicon" id={logo.skillName}>
						                  <div className="iconcontent">
						                    {logo.fontAwesomeClassname && (
						                      <span
						                        className="iconify"
						                        data-icon={logo.fontAwesomeClassname}
						                        style={logo.style}
						                        data-inline="false"
						                      ></span>
						                    )}
						                    {!logo.fontAwesomeClassname && logo.imageSrc && (
						                      <img
						                        className="skill-image"
						                        style={logo.style}
						                        src={`${process.env.PUBLIC_URL}/skills/${logo.imageSrc}`}
						                        alt={logo.skillName}
						                      />
						                    )}
						                    <h4>{logo.skillName}</h4>
						                  </div>
						                  </div>
						                </OverlayTrigger>
						              );
						            })}
						          </div>
						        </div>
						      </div>
                 
                 
                </Fade>
              </div>
            </div>
          );
        })}
      </div>
      
      </div>
              
      </PageLayout>
    );
}